import script from "./iron_ofc_view.vue?vue&type=script&setup=true&lang=js"
export * from "./iron_ofc_view.vue?vue&type=script&setup=true&lang=js"

import "./iron_ofc_view.vue?vue&type=style&index=0&id=75c5f390&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75c5f390"]])

export default __exports__